import { render, staticRenderFns } from "./WrongContractDetail.vue?vue&type=template&id=64965478&"
import script from "./WrongContractDetail.vue?vue&type=script&lang=js&"
export * from "./WrongContractDetail.vue?vue&type=script&lang=js&"
import style0 from "./WrongContractDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports